import { useGetAgency } from "@/hooks/agencies";
import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";
import { TourAgenciesPage } from "./-components";
import { useGetTour } from "@/hooks/tours";

export const Route = createFileRoute("/(tour-agencies)/tour-agencies/$id")({
  component: RouteComponent,
  validateSearch: z.object({
    domain: z.enum(["agency", "tour"]),
  }),
});

function RouteComponent() {
  const { domain } = Route.useSearch();
  if (domain === "agency") return <TourAgencyForAgency />;
  return <TourAgencyForTour />;
}

function TourAgencyForAgency() {
  const { id } = Route.useParams();
  const { data: agency, isLoading } = useGetAgency(id);
  return (
    <TourAgenciesPage
      domain="agency"
      domainId={id}
      domainLoading={isLoading}
      domainName={agency?.name}
      editLink={(taId, children, key) => (
        <Link
          key={key}
          to="/tour-agencies/$id/edit/$taId"
          params={{ id, taId }}
          search={{ domain: "agency" }}
        >
          {children}
        </Link>
      )}
    />
  );
}
function TourAgencyForTour() {
  const { id } = Route.useParams();
  const { data: tour, isLoading } = useGetTour(id);
  return (
    <TourAgenciesPage
      domain="tour"
      domainId={id}
      domainLoading={isLoading}
      domainName={tour?.name}
      editLink={(taId, children, key) => (
        <Link
          key={key}
          to="/tour-agencies/$id/edit/$taId"
          params={{ id, taId }}
          search={{ domain: "tour" }}
        >
          {children}
        </Link>
      )}
    />
  );
}
